import styled from "styled-components";

import colors from "../../../../../constants/color";
import materialUI from "../../../../../material-UI";

export const FormControl = styled(materialUI.FormControl)`
  display: flex;
  width: 100%;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const Select = styled(materialUI.Select)`
  width: 100%;
  margin-bottom: 12px;

  &.select-historic {
    width: 100%;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.gray300};
    border-radius: 8px;
    legend {
      span {
        display: none;
      }
    }
  }
`;

export const MenuItemSelect = styled(materialUI.MenuItem)``;

export const ListWrapper = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const CircularProgressTasks = styled(materialUI.CircularProgress)`
  color: ${colors.primary};
  width: 25px !important;
  height: 25px !important;
  margin: 0 auto;
  display: block;
  margin-top: 50px;
`;

export const Text = styled.div`
  font-family: Inter;
  font-size: 14px;
  color: ${colors.grey9};
  margin: 8px 0px -4px 8px;

  &.text-title {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${colors.grey1};
    margin: 0;
  }
  &.header-title {
    font-family: Inter-Medium;
    font-size: 18px;
    line-height: 22px;
    letter-spacing: 0.015em;
    color: ${colors.almostBlack};
    margin: 0;
    margin-right: 10px;
  }
  &.text-data {
    font-size: 14px;
    line-height: 15px;
    color: ${colors.grey3};
    margin: 0;
  }
  &.text-temperatura {
    margin-top: 10px;
  }
`;
